import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../app/store';

export interface DebugState {
  debugOpen: boolean;
  debugCurrCollectionId: string;
  debugCollectionIdSearch: string;
  debugRefreshTrigger: number | null;
}

const initialState: DebugState = {
  debugOpen: false,
  debugCurrCollectionId: '',
  debugCollectionIdSearch: '',
  debugRefreshTrigger: null,
};

export const debugStateSlice = createSlice({
  name: 'debug',
  initialState,
  reducers: {
    initDebugState: () => initialState,
    setDebugOpen: (state, action: PayloadAction<boolean>) => {
      state.debugOpen = action.payload;
    },
    setDebugCurrCollectionId: (state, action: PayloadAction<string>) => {
      state.debugCurrCollectionId = action.payload;
    },
    setDebugCollectionIdSearch: (state, action: PayloadAction<string>) => {
      state.debugCollectionIdSearch = action.payload;
    },
    setDebugRefreshTrigger: (state, action: PayloadAction<number>) => {
      state.debugRefreshTrigger = action.payload;
    },
  },
});

export const {
  initDebugState,
  setDebugOpen,
  setDebugCurrCollectionId,
  setDebugCollectionIdSearch,
  setDebugRefreshTrigger,
} = debugStateSlice.actions;

export const selectDebugOpen = (state: RootState) => state.debug.debugOpen;
export const selectDebugCurrCollectionId = (state: RootState) =>
  state.debug.debugCurrCollectionId;
export const selectDebugCollectionIdSearch = (state: RootState) =>
  state.debug.debugCollectionIdSearch;
export const selectDebugRefreshTrigger = (state: RootState) =>
  state.debug.debugRefreshTrigger;

export const selectAllDebug = (state: RootState) => state.debug;

export default debugStateSlice.reducer;
